<template>
    <div>
        <div class="app-title">
            <em-view-title ref="viewTitle" :crudState="$_emCommonListMixin_pathType"></em-view-title>
        </div>
        <section class="app-content" v-menu-permission="'list'">
            <div id="accordionFilter" class="content">
                <div class="card">
                    <div id="collapseOne" class="collapse show" aria-labelledby="headingOne"
                         data-parent="#accordionFilter">
                        <div class="card-body">
                            <form>
                                <em-filter :entity="modelName" ref="emListFilter"
                                           :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                           :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                           :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                           @showEntityModalSelect="$_emCommonModalMixin_showModalSelectorByFilter"
                                           @showEntityMultipleModalSelect="$_emCommonModalMixin_showMultipleSelectorByFilter"></em-filter>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div id="sithMesStoolTransferTicketGenerationRecordResultTable" class="content">
                <div class="card my-1">
                    <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo"
                         data-parent="#accordionResult">
                        <div class="card-body">
                            <em-table :entity="modelName"
                                      :$_em-custom-vuex-mixin_entity="$_emCustomVuexMixin_entity"
                                      :$_em-custom-vuex-mixin_filter="$_emCustomVuexMixin_filter"
                                      :$_em-custom-vuex-mixin_vo="$_emCustomVuexMixin_vo"
                                      ref="emTable" withCustomRowActions header-btn-edit-disabled header-btn-add-disabled
                                      :inlineActionsDisabled="prop_inline!=='1'"
                                      @showModalSelectorByNewRow="$_emCommonModalMixin_showModalSelectorByNewRow"
                                      @showModalSelectorByEditRow="$_emCommonModalMixin_showModalSelectorByEditRow"
                                      @linkClick="whenLinkClick">
                                <template #customRowActions="{row}">
                                    <b-button-group>
                                        <em-button type="gotoChild"
                                                   v-bind:class="'btn btn-outline-primary btn-sm'"
                                                   @click="gotoChild(row)">
                                        </em-button>
                                    </b-button-group>
                                </template>
                            </em-table>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <em-modal-entity-selector ref="emModalEntitySelector"></em-modal-entity-selector>
    </div>
</template>
<script>
    // Author lidongxu
    // Date 2023-12-29 16:39:45

    import emCommonListMixin from "@/mixin/em/common/list";
    import emCustomVuexMixin from "@/mixin/em/customVuex";
    import emCommonGotoMixin from "@/mixin/em/common/goto";
    import EmCommonApi from "@/mixin/em/common/api";
    import emWebSocketMixin from "@/mixin/em/common/webSocket";

    export default {
        name: "sithMesStoolTransferTicketGenerationRecordListView",
        mixins: [emCommonListMixin, emCustomVuexMixin, emCommonGotoMixin,EmCommonApi,emWebSocketMixin],

        props: {
            //是否启用行编辑
            prop_inline: {
                type: String,
                default: "0"
            }
        },
        methods: {
            gotoChild(row) {
                this.$_emGotoMixin_gotoHolderList("sithMesStoolTransferTicketDetail"
                       , {transferTicketNoFilter: row.transferTicketNo}
                       , {transferTicketNo: row.transferTicketNo}, false, {})
            },
            whenLinkClick(key, row) {
                if (key === 'originFileName') {
                    let downloadUrl = process.env.VUE_APP_REPORT_API_URL+'report-service/mmf/report/reportGenerated/download/'+row.originFileId;
                    let a = document.createElement('a');
                    a.href = downloadUrl;
                    a.download = ''; // 让浏览器按后端 `Content-Disposition` 处理
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                }
            },
        },
        computed: {

            modelName() {
                return this.$_emRouterHelperMixin_entityName

            }
        }
    };
</script>
